'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  function splice(context) {
    var _context$target$type;

    if (!context.resolve.isTag(target, 'state', 'module')) {
      throw new Error('Cerebral operator.splice: You have to use the STATE or MODULE tag as first argument');
    }

    var spliceArgs = args.map(function (arg) {
      return context.resolve.value(arg);
    });

    (_context$target$type = context[target.type]).splice.apply(_context$target$type, [context.resolve.path(target)].concat(_toConsumableArray(spliceArgs)));
  }

  splice.displayName = 'operator.splice(' + String(target) + ', ' + args.map(function (arg) {
    return String(arg);
  }).join(',') + ')';

  return splice;
};

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
//# sourceMappingURL=splice.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/operators/splice.js
// module id = 275
// module chunks = 0